module.exports = __webpack_public_path__ + "img/webhooks.08b9f487.svg";